var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffwrist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1997",
    "data-name": "Group 1997",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.742,
    height: 26.742,
    viewBox: "0 0 26.742 26.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17267",
    "data-name": "Rectangle 17267",
    width: 26.739,
    height: 26.738,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7503",
    "data-name": "Path 7503",
    d: "M17.607,8.1V7.245a.8.8,0,0,0-.8-.8H13.431a.8.8,0,0,0-.8.8V8.1a7.125,7.125,0,0,0,0,13.36V22.2a.914.914,0,0,0,.915.915h3.15a.914.914,0,0,0,.915-.915V21.46a7.125,7.125,0,0,0,0-13.361Z",
    transform: "translate(-1.748 -1.411)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8066",
    "data-name": "Path 8066",
    d: "M14.206,14.295l4.1,4.1",
    transform: "translate(-3.11 -3.131)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8067",
    "data-name": "Path 8067",
    d: "M0,0,4.1,4.1",
    transform: "translate(15.191 11.164) rotate(90)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_7505",
    "data-name": "Path 7505",
    transform: "translate(0 0)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.371,0A13.371,13.371,0,1,1,0,13.371,13.371,13.371,0,0,1,13.371,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.37091732025146 1.999998092651367 C 10.33363723754883 1.999998092651367 7.478147506713867 3.182777404785156 5.330467224121094 5.330467224121094 C 3.182777404785156 7.478147506713867 1.999998092651367 10.33363723754883 1.999998092651367 13.37091732025146 C 1.999998092651367 16.4081974029541 3.182777404785156 19.26368713378906 5.330467224121094 21.41136741638184 C 7.478147506713867 23.55905723571777 10.33363723754883 24.74183654785156 13.37091732025146 24.74183654785156 C 16.4081974029541 24.74183654785156 19.26368713378906 23.55905723571777 21.41136741638184 21.41136741638184 C 23.55905723571777 19.26368713378906 24.74183654785156 16.4081974029541 24.74183654785156 13.37091732025146 C 24.74183654785156 10.33363723754883 23.55905723571777 7.478147506713867 21.41136741638184 5.330467224121094 C 19.26368713378906 3.182777404785156 16.4081974029541 1.999998092651367 13.37091732025146 1.999998092651367 M 13.37091732025146 -1.9073486328125e-06 C 20.75546646118164 -1.9073486328125e-06 26.74183654785156 5.986368179321289 26.74183654785156 13.37091732025146 C 26.74183654785156 20.75546646118164 20.75546646118164 26.74183654785156 13.37091732025146 26.74183654785156 C 5.986368179321289 26.74183654785156 -1.9073486328125e-06 20.75546646118164 -1.9073486328125e-06 13.37091732025146 C -1.9073486328125e-06 5.986368179321289 5.986368179321289 -1.9073486328125e-06 13.37091732025146 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#1d3378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffwrist);
export default __webpack_public_path__ + "static/media/offwrist.b443c470a7afe7ae92df46bf67ce787a.svg";
export { ForwardRef as ReactComponent };